export default __webpack_public_path__ + "static/media/Social Physical Learner.bddb686c.png";